// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__3nXJb","colMaxWidth":"Table_colMaxWidth__p7H4_"};